import { pageMap } from '../mapping/page-mapping';
import { UrlSegmentDelimiter } from '../../constants-repository/app-style.constants';
import { PageKey } from '../page-keys';

export interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  cssClass;
  subRoutes?: RouteInfo[];
}

export const SIDEBAR_ROUTES: RouteInfo[] = [
  {
    path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.DashboardPageKeys.Dashboard),
    title: pageMap.getTitle(PageKey.DashboardPageKeys.Dashboard),
    icon: 'dashboard.svg',
    cssClass: 'dashboard',
  },
  {
    path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.TimeTrackingPageKeys.TimeTracking),
    title: pageMap.getTitle(PageKey.TimeTrackingPageKeys.TimeTracking),
    icon: 'time-tracking.svg',
    cssClass: 'time-tracking',
    subRoutes: [
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.TimeTrackingPageKeys.CalendarView),
        title: pageMap.getTitle(PageKey.TimeTrackingPageKeys.CalendarView),
        icon: '',
        cssClass: 'calendar-view',
      },
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.TimeTrackingPageKeys.ListView),
        title: pageMap.getTitle(PageKey.TimeTrackingPageKeys.ListView),
        icon: '',
        cssClass: 'list-view',
      },
    ],
  },
  {
    path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.ProjectPageKeys.Projects),
    title: pageMap.getTitle(PageKey.ProjectPageKeys.Projects),
    icon: 'projects.svg',
    cssClass: 'projects',
    subRoutes: [
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.ProjectPageKeys.ProjectOverview),
        title: pageMap.getTitle(PageKey.ProjectPageKeys.ProjectOverview),
        icon: '',
        cssClass: 'list-project',
      },
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.ProjectPageKeys.ProjectAdd),
        title: pageMap.getTitle(PageKey.ProjectPageKeys.ProjectAdd),
        icon: '',
        cssClass: 'add-project',
      },
    ],
  },
  {
    path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.ClientPageKeys.Clients),
    title: pageMap.getTitle(PageKey.ClientPageKeys.Clients),
    icon: 'clients.svg',
    cssClass: 'clients',
    subRoutes: [
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.ClientPageKeys.ClientList),
        title: pageMap.getTitle(PageKey.ClientPageKeys.ClientList),
        icon: '',
        cssClass: 'show-clients',
      },
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.ClientPageKeys.ClientAdd),
        title: pageMap.getTitle(PageKey.ClientPageKeys.ClientAdd),
        icon: '',
        cssClass: 'add-client',
      },
    ],
  },
  {
    path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.TeamPageKeys.Team),
    title: pageMap.getTitle(PageKey.TeamPageKeys.Team),
    icon: 'team.svg',
    cssClass: 'team',
    subRoutes: [
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.TeamPageKeys.TeamOverview),
        title: pageMap.getTitle(PageKey.TeamPageKeys.TeamOverview),
        icon: '',
        cssClass: 'list-team',
      },
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.TeamPageKeys.TeamMemberAdd),
        title: pageMap.getTitle(PageKey.TeamPageKeys.TeamMemberAdd),
        icon: '',
        cssClass: 'add-team-member',
      },
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.TeamPageKeys.TeamAbsences),
        title: pageMap.getTitle(PageKey.TeamPageKeys.TeamAbsences),
        icon: '',
        cssClass: 'absences',
      },
    ],
  },
  {
    path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.FinancePageKeys.Finances),
    title: pageMap.getTitle(PageKey.FinancePageKeys.Finances),
    icon: 'finances.svg',
    cssClass: 'finances',
    subRoutes: [
      {
        path:
          UrlSegmentDelimiter + pageMap.getRoute(PageKey.FinancePageKeys.FinancesInvoicesOverview),
        title: pageMap.getTitle(PageKey.FinancePageKeys.FinancesInvoicesOverview),
        icon: '',
        cssClass: 'list-invoices',
      },
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.FinancePageKeys.FinancesInvoicesAdd),
        title: pageMap.getTitle(PageKey.FinancePageKeys.FinancesInvoicesAdd),
        icon: '',
        cssClass: 'add-invoice',
      },
      {
        path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.FinancePageKeys.FinancesExpenses),
        title: pageMap.getTitle(PageKey.FinancePageKeys.FinancesExpenses),
        icon: '',
        cssClass: 'operating-expenses',
      },
    ],
  },
  {
    path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.ReportsPageKeys.Reports),
    title: pageMap.getTitle(PageKey.ReportsPageKeys.Reports),
    icon: 'reports.svg',
    cssClass: 'reports',
    subRoutes: [
      {
        path:
          UrlSegmentDelimiter +
          pageMap.getRoute(PageKey.ReportsPageKeys.ReportsTimetableAggregated),
        title: pageMap.getTitle(PageKey.ReportsPageKeys.ReportsTimetableAggregated),
        icon: '',
        cssClass: 'reports-timetable',
      },
    ],
  },
  {
    path: UrlSegmentDelimiter + pageMap.getRoute(PageKey.TodoPlannerPageKeys.TodoPlanner),
    title: pageMap.getTitle(PageKey.TodoPlannerPageKeys.TodoPlanner),
    icon: 'todo.svg',
    cssClass: 'todo',
  },
];
